import { Site } from '@envato/foundation-types'

import { toTitle } from '../utils/formatString'
import ga from '../utils/ga'
import { getCurrentSiteDomain } from '../utils/sites'

interface IElementsItem {
  title: string
  author: string
  marketID: number
}

export const reportCategoryPageClick = (eventLabel: string) => () => {
  ga('send', {
    hitType: 'event',
    eventCategory: 'CategoryPage',
    eventAction: 'click',
    eventLabel
  })
}

export const reportElementsProductsImpressions = ({
  items,
  currentSite,
  itemRankOffset,
  category,
  page,
  section
}: {
  items: IElementsItem[]
  currentSite: Site
  itemRankOffset: number
  category?: string
  page?: string
  section?: string
}) => {
  const currentSiteDomain = getCurrentSiteDomain(currentSite)
  const list =
    page && section
      ? `${page}: ${toTitle(section)}`
      : 'Product list name not specified'

  items.forEach((item, index) => {
    ga('ec:addImpression', {
      brand: item.author,
      ...(category ? { category: `${currentSiteDomain}/${category}` } : {}),
      id: item.marketID,
      list,
      name: item.title,
      position: index + itemRankOffset
    })
  })
  ga('send', 'event', 'Ecommerce', 'view', 'Product impression', {
    nonInteraction: true
  })
}
